import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import App from './App';
import Login from './pages/Login';
import LandingPage from './pages/LandingPage';
import { ETLProjectPage } from './features/etl-monitor';
import { TenantAdminPage } from './features/admin';
import ProtectedRoute from './components/ProtectedRoute';
import AppErrorBoundary from './components/common/AppErrorBoundary';
import { AuthProvider } from './stores/AuthContext';
// Mounted here (not in AppProviders) so it's a true ancestor of every route —
// App.jsx renders AppProviders as a child partway through its own JSX, and
// LandingPage/ETLProjectPage are routed outside AppProviders entirely. See
// AppProviders.jsx's note.
import { WorkshopModeProvider } from './stores/WorkshopModeContext';
import SentryFeedbackWorkshopGate from './components/common/SentryFeedbackWorkshopGate';
// Side-effect import: initialises i18next before anything renders. Must live
// here rather than in AppProviders — Login, LandingPage and ETLProjectPage are
// rendered outside AppProviders, so a provider would miss them.
import './i18n';
// Side-effect import: initialises Sentry (no-op if VITE_SENTRY_DSN unset)
// before anything else renders, same reasoning as the i18n import above.
import './lib/sentry';
import './styles/globals.css'

// Embeds a unique, commit-scoped string in the built bundle so every real
// deploy gets a new Vite content hash (busts the 1y-immutable asset cache
// even when a fix is env/config-only). Also lets support ask a user to paste
// window.__CINTELION_BUILD__ to confirm which build their browser is running.
window.__CINTELION_BUILD__ = {
  version: import.meta.env.VITE_VERSION,
  commit: import.meta.env.VITE_GIT_COMMIT,
  branch: import.meta.env.VITE_GIT_BRANCH,
  buildDate: import.meta.env.VITE_BUILD_DATE,
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <AuthProvider>
        <WorkshopModeProvider>
          <SentryFeedbackWorkshopGate />
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={
                <ProtectedRoute>
                  <LandingPage />
                </ProtectedRoute>
              } />
              <Route path="/projects" element={
                <ProtectedRoute requireMetadataKey="etl_admin_access">
                  <ETLProjectPage />
                </ProtectedRoute>
              } />
              <Route path="/admin/tenants" element={
                <ProtectedRoute adminOnly>
                  <TenantAdminPage />
                </ProtectedRoute>
              } />
              <Route path="/dashboard/*" element={
                <ProtectedRoute>
                  <App />
                </ProtectedRoute>
              } />
            </Routes>
          </BrowserRouter>
        </WorkshopModeProvider>
      </AuthProvider>
    </AppErrorBoundary>
  </React.StrictMode>
);